import { createSelector } from 'reselect'
import { RootStoreState } from '@src/models/app.types'
import { DEFAULT_NOTIFICATION_INBOX_LIST_STATE } from '@src/models/notifications/types'
import { NotificationInboxStateFilter } from '@src/types'

export const notificationsStoreSelector = (state: RootStoreState) => state.notifications

export const notificationsLastFetchedAtSelector = createSelector(
  notificationsStoreSelector,
  (store) => store.lastFetchedAt,
)

export const activeNotificationsSelector = createSelector(
  notificationsStoreSelector,
  (store) => store.notifications,
)

export const liveNotificationsSelector = createSelector(
  notificationsStoreSelector,
  (store) => store.liveNotifications,
)

export const notificationInboxSelector = createSelector(
  notificationsStoreSelector,
  (store) => store.inbox,
)

export const notificationInboxNotificationsSelector = createSelector(
  notificationInboxSelector,
  (inbox) => inbox.notifications,
)

export const notificationInboxUnreadCountSelector = createSelector(
  notificationInboxSelector,
  (inbox) => inbox.unreadCount,
)

export const notificationInboxRecordsSelector = (stateFilter: NotificationInboxStateFilter) =>
  createSelector(
    notificationInboxNotificationsSelector,
    (notifications) =>
      notifications[stateFilter]?.records ?? DEFAULT_NOTIFICATION_INBOX_LIST_STATE.records,
  )

export const notificationInboxNextCursorSelector = (stateFilter: NotificationInboxStateFilter) =>
  createSelector(
    notificationInboxNotificationsSelector,
    (notifications) =>
      notifications[stateFilter]?.nextCursor ?? DEFAULT_NOTIFICATION_INBOX_LIST_STATE.nextCursor,
  )
